import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const cartSummaryDefaultVariants = {}
const cartSummaryCompoundVariants = []

const cartSummarySlotNames = [
  [
    "root",
    "cartSummary__root"
  ],
  [
    "row",
    "cartSummary__row"
  ],
  [
    "title",
    "cartSummary__title"
  ]
]
const cartSummarySlotFns = /* @__PURE__ */ cartSummarySlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, cartSummaryDefaultVariants, getSlotCompoundVariant(cartSummaryCompoundVariants, slotName))])

const cartSummaryFn = memo((props = {}) => {
  return Object.fromEntries(cartSummarySlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const cartSummaryVariantKeys = []
const getVariantProps = (variants) => ({ ...cartSummaryDefaultVariants, ...compact(variants) })

export const cartSummary = /* @__PURE__ */ Object.assign(cartSummaryFn, {
  __recipe__: false,
  __name__: 'cartSummary',
  raw: (props) => props,
  variantKeys: cartSummaryVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, cartSummaryVariantKeys)
  },
  getVariantProps
})